import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findRevenuesTurn({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`revenues/findRevenuesTurn`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findRevenuesBack({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`revenues/findRevenuesBack`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findPayment({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`revenues/findPayment`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  intDictionary({ commit }, params) {
		return new Promise((resolve, reject) => {
			let  getGaokaoYear  = axios.get("/dictionary/findAllItemByTypeCode", {params: {typeCode: "gaokaoYear"}})
			Promise.all([getGaokaoYear])
			.then(res => {
				resolve(res)
			}).catch(error=> {
				console.log(error)
			}) 
		})
  },
}